var _classCallCheck = require("/home/amt/agmtv2/autographa-mt/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/amt/agmtv2/autographa-mt/node_modules/@babel/runtime/helpers/createClass");

// ABSTARCT class
var Parser =
/*#__PURE__*/
function () {
  "use strict";

  function Parser() {
    _classCallCheck(this, Parser);

    if (this.constructor === Parser) {
      throw new Error("Abstract classes can't be instantiated.");
    }
  }

  _createClass(Parser, null, [{
    key: "validate",
    value: function validate() {
      throw new Error("Method 'validate()' must be implemented.");
    }
  }, {
    key: "noramlize",
    value: function noramlize() {
      throw new Error("Method 'noramlize()' must be implemented.");
    }
  }, {
    key: "convert",
    value: function convert() {
      throw new Error("Method 'convert()' must be implemented.");
    }
  }]);

  return Parser;
}();

exports.Parser = Parser;